import { useEffect, useState } from "react";

import Image from "next/legacy/image";
import { blurDataURL, stadium1 } from "../../../utils/constants/images";
import {
  convertTo24HrTime,
  convertToShortDate,
} from "../../../utils/helpers/dateAndTime";
import TeamName from "./TeamName";
import TeamLogo from "./TeamLogo";

export const NextMatchBanner = ({ fixture }) => {
  const [fixtureTime, setFixtureTime] = useState("");
  const [fixtureDate, setFixtureDate] = useState("");

  useEffect(() => {
    setFixtureTime(convertTo24HrTime(fixture.date_and_time));
    setFixtureDate(convertToShortDate(fixture.date_and_time));
  }, [fixture.date_and_time]);

  return (
    <div className="relative h-60 md:h-64 lg:h-72 xl:h-80 2xl:h-96 mx-2 sm:mx-4 lg:mx-auto lg:max-w-5xl xl:max-w-6xl 2xl:max-w-[1220px] mb-20">
      <div className="absolute h-full w-full mx-auto object-cover mix-blend-multiply">
        <Image
          src={stadium1}
          alt="Baba Yara Stadium"
          layout="fill"
          objectFit="cover"
          priority
          className="object-cover mix-blend-multiply"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-red-800 dark:from-green-800 to-red-700 dark:to-green-700 mix-blend-multiply"></div>
      </div>
      <div className="absolute p-2 pl-4 sm:pl-4 flex justify-between">
        <p className="text-white text-xs sm:text-sm">{"Next Match "}</p>
      </div>

      <div className="absolute flex flex-col justify-center items-center inset-0 mr-10 ml-10 space-y-10">
        <div className="absolute flex justify-between items-start">
          <div className="flex flex-col justify-center items-center space-y-2">
            <TeamLogo teamLogo={fixture.home_team_logo} />

            <TeamName teamName={fixture.home_team} />
          </div>

          <div className="flex flex-col justify-center items-center pt-3 sm:pt-6 sm:px-16 text-center">
            <div className="pb-2">
              <p className="text-white text-sm  sm:text-base font-extrabold">
                {fixtureTime}
              </p>
              <p className="text-white text-sm">{fixtureDate}</p>
            </div>
            <p className="text-red-300 dark:text-green-300 text-xs mx-4 truncate w-24 sm:w-40 text-ellipsis">
              {fixture.venue}
            </p>
          </div>
          <div className="flex flex-col justify-center items-center space-y-2">
            <TeamLogo teamLogo={fixture.away_team_logo} />

            <TeamName teamName={fixture.away_team} />
          </div>
        </div>
      </div>
      <div className="absolute bottom-4 left-0 right-0 flex flex-col items-center justify-center text-center mx-auto text-red-300 dark:text-green-300  text-xs">
        <p className="w-[70vw] truncate text-ellipsis">{fixture.competition}</p>
        <p className="w-[70vw] truncate text-ellipsis">
          {fixture.week_or_round_number}
        </p>
      </div>
    </div>
  );
};

export default NextMatchBanner;
